export const allColumns = [
    { id: "buy_price", label: "Buy Price", visible: true, category: "Core" },
    { id: "max_investment", label: "Limit × Buy Price", visible: false, category: "Limit" },
    { id: "sell_price", label: "Sell Price", visible: true, category: "Core" },
    { id: "margin", label: "Margin", visible: true, category: "Core" },
    { id: "max_profit", label: "Limit × Profit", visible: false, category: "Limit" },
    { id: "roi", label: "ROI%", visible: true, category: "Core" },
    { id: "spread", label: "Spread%", visible: false, category: "Core" },
    { id: "limit", label: "Limit", visible: true, category: "Limit" },

    // Volume
    { id: "volume_5m", label: "Volume (5m)", visible: false, category: "Volume" },
    { id: "volume_1h", label: "Volume (1h)", visible: false, category: "Volume" },
    { id: "volume_6h", label: "Volume (6h)", visible: false, category: "Volume" },
    { id: "volume_24h", label: "Volume (24h)", visible: false, category: "Volume" },
    { id: "volume_7d", label: "Volume (7d)", visible: false, category: "Volume" },

    // Turnover
    { id: "turnover_5m", label: "Turnover (5m)", visible: false, category: "Turnover" },
    { id: "turnover_1h", label: "Turnover (1h)", visible: false, category: "Turnover" },
    { id: "turnover_6h", label: "Turnover (6h)", visible: false, category: "Turnover" },
    { id: "turnover_24h", label: "Turnover (24h)", visible: false, category: "Turnover" },
    { id: "turnover_7d", label: "Turnover (7d)", visible: false, category: "Turnover" },
    { id: "turnover_1m", label: "Turnover (1m)", visible: false, category: "Turnover" },

    // Trend
    { id: "trend_5m", label: "Trend (5m)", visible: false, category: "Trend" },
    { id: "trend_1h", label: "Trend (1h)", visible: false, category: "Trend" },
    { id: "trend_6h", label: "Trend (6h)", visible: false, category: "Trend" },
    { id: "trend_24h", label: "Trend (24h)", visible: false, category: "Trend" },
    { id: "trend_7d", label: "Trend (7d)", visible: false, category: "Trend" },
    { id: "trend_1m", label: "Trend (1m)", visible: false, category: "Trend" },

    // Buy/Sell Ratio
    { id: "buy_sell_rate_5m", label: "Buy/Sell Rate (5m)", visible: false, category: "Buy/Sell Ratio" },
    { id: "buy_sell_rate_1h", label: "Buy/Sell Rate (1h)", visible: false, category: "Buy/Sell Ratio" },
    { id: "buy_sell_rate_6h", label: "Buy/Sell Rate (6h)", visible: false, category: "Buy/Sell Ratio" },
    { id: "buy_sell_rate_24h", label: "Buy/Sell Rate (24h)", visible: false, category: "Buy/Sell Ratio" },
    { id: "buy_sell_rate_7d", label: "Buy/Sell Rate (7d)", visible: false, category: "Buy/Sell Ratio" },
];
